import React, { useEffect } from 'react';
import _get from 'lodash/get';
import Assessment from 'containers/Assessment';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import LoadingIndicator from 'components/LoadingIndicator';
import { useFirestore } from 'react-redux-firebase';
import { getAnswersWithResults } from 'containers/Assessment/actions';
import { SeriesAssessmentResult } from '../main/SeriesAssessmentResult';

const getCurrentAssessmentAccessCodes = ({
  item,
  accessCode,
  completedAssessments,
}) => {
  const all = completedAssessments
    .filter(i => item.sys.id === i.id)
    .map(i => i.accessCode);

  return all[0] === accessCode ? [accessCode] : all;
};

export const SeriesAssessmentPreview = ({
  series,
  item,
  completeSeriesAssessment,
  completedAssessments = [],
  actionsNode,
  showShareButton,
  linkAsPlainText,
  small,
  trackingProps,
  spanFullWidth,
}) => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const firestore = useFirestore();
  const history = useHistory();

  const found = completedAssessments.find(
    i => item.sys.id === i.id && i.seriesId === series.sys.id,
  );
  const accessCode = found?.accessCode;
  const accessCodes = getCurrentAssessmentAccessCodes({
    item,
    accessCode,
    completedAssessments,
  });
  const answers = useSelector(state => state.assessment.answers);
  const assessmentResult = useSelector(
    state => state.assessment.assessmentResult,
  );
  const answersProcessing = useSelector(
    state => state.assessment.answersProcessing,
  );

  const isStaleAnswers = _get(answers, 'assessment.assessmentID') !== found?.id;

  useEffect(() => {
    if (accessCode && accessCodes.length) {
      dispatch(getAnswersWithResults({ accessCodes, item }));
      history.replace(match.url);
    }
  }, [accessCodes.toString(), accessCode]);

  useEffect(() => {
    if (!accessCode && answers && !answers.accessCode) {
      const unsubscribe = firestore
        .collection('assessment_reports')
        .doc(answers.report)
        .onSnapshot(snapshot => {
          const data = snapshot.data();
          if (data.accessCode) {
            completeSeriesAssessment(item, data.accessCode);
            history.replace(match.url);
            unsubscribe();
          }
        });
    }
  }, [answers]);

  const hasAnswers = !!_get(answers, 'accessCode') && !isStaleAnswers;
  const isProcessing = answersProcessing || (!!accessCode && !hasAnswers);

  if (isProcessing) return <LoadingIndicator />;

  const assessmentPath = `${match.url}/assessments/${item.fields.slug}`;

  return hasAnswers ? (
    <SeriesAssessmentResult
      assessment={item}
      answers={answers}
      assessmentResult={assessmentResult}
      actionsNode={actionsNode}
      showShareButton={showShareButton}
      linkAsPlainText={linkAsPlainText}
      small={small}
    />
  ) : (
    <Assessment
      assessment={{ items: [item] }}
      assessmentPath={assessmentPath}
      trackingProps={trackingProps}
      spanFullWidth={spanFullWidth}
    />
  );
};
